/** @file useFitPrompt: the Art fit prompt (Pad / Scale / Cancel) as a promise, for the inspector's Rig block. */
import type { ReactElement } from 'react';
import { useCallback, useState } from 'react';
import type { FitMode, MisfitImage } from '../art/artTypes';
import { BulkFitPrompt } from '../art/BulkFitPrompt';

/** A question waiting for its answer: the misfits and the promise's resolve. */
type FitAsk = { misfits: MisfitImage[]; resolve: (fit: FitMode | null) => void };

/** `askFit` opens the prompt and resolves with the choice (null = cancel); `prompt` is the open dialog, or null. */
export type FitPrompt = { askFit: (misfits: MisfitImage[]) => Promise<FitMode | null>; prompt: ReactElement | null };

/** The viewport's prompt, owned by the inspector: render `prompt` anywhere in the panel. */
export function useFitPrompt(): FitPrompt {
  const [ask, setAsk] = useState<FitAsk | null>(null);
  const askFit = useCallback((misfits: MisfitImage[]) => new Promise<FitMode | null>((resolve) => { setAsk({ misfits, resolve }); }), []);
  const prompt = ask === null ? null : <BulkFitPrompt misfits={ask.misfits} choose={(fit) => { setAsk(null); ask.resolve(fit); }} />;
  return { askFit, prompt };
}
